// Strings locales del módulo M6 · Auditoría (docs/08 Ola C).
export const auditI18n = {
  title: "Auditoría",
  description: "Registro de eventos de la instancia: internos del sistema y externos de las apps.",
  searchEvent: "Filtrar por evento (p. ej. auth.login.failed)",
  searchActor: "Filtrar por actor (id)",
  filterSource: "Origen",
  sources: { all: "Todos", internal: "Internos", external: "Externos" },
  export: "Exportar CSV",
  columns: {
    occurredAt: "Fecha",
    event: "Evento",
    actor: "Actor",
    source: "Origen",
    target: "Objetivo",
  },
  empty: {
    title: "Sin eventos",
    description: "Cuando ocurran acciones auditables aparecerán aquí.",
  },
} as const
